module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-cebrity-jamie-foxx-1dced4ebd509a14cfad358bd58f2be00.png";